<template>
  <form @submit.prevent="submit">
    <div class="mb-3">
      <label class="va-input__label">Тип доставки</label>
      <select
        v-model="form.delivery_type_id"
        class="form-control"
        :class="{ 'form-control--error': errors.delivery_type_id }"
      >
        <option value="">Выберите тип доставки</option>
        <option
          v-for="opt in deliveryTypeSelectOptions"
          :key="opt.value"
          :value="opt.value"
        >
          {{ opt.text }}
        </option>
      </select>
      <span v-if="errors.delivery_type_id" class="error-message">{{ errors.delivery_type_id }}</span>
    </div>
    <div class="mb-3">
      <label class="va-input__label">Время от</label>
      <input
        v-model="form.time_from"
        type="time"
        class="form-control"
        required
      />
    </div>
    <div class="mb-3">
      <label class="va-input__label">Время до</label>
      <input v-model="form.time_to" type="time" class="form-control" required />
    </div>
    <va-checkbox v-model="form.is_active" label="Активен" class="mb-4" />
    <div class="d-flex gap-2">
      <va-button type="submit" color="primary">Сохранить</va-button>
      <va-button type="button" @click="$emit('cancel')">Отмена</va-button>
    </div>
  </form>
</template>

<script>
export default {
  name: "DeliverySlotForm",
  props: {
    initial: { type: Object, default: null },
    deliveryTypes: { type: Array, default: () => [] },
  },
  data() {
    return {
      form: {
        delivery_type_id: "",
        time_from: "",
        time_to: "",
        is_active: true,
      },
      errors: {},
    };
  },
  computed: {
    deliveryTypeSelectOptions() {
      return (this.deliveryTypes || [])
        .filter((o) => o.value != null && o.value !== "")
        .map((o) => ({ value: Number(o.value), text: o.text || String(o.value) }));
    },
  },
  watch: {
    initial: {
      immediate: true,
      handler(val) {
        if (val) {
          this.form = {
            delivery_type_id:
              val.delivery_type_id != null && val.delivery_type_id !== ""
                ? Number(val.delivery_type_id)
                : "",
            time_from: this.toTimeInput(val.time_from),
            time_to: this.toTimeInput(val.time_to),
            is_active: !!val.is_active,
          };
        } else {
          this.form = {
            delivery_type_id: "",
            time_from: "",
            time_to: "",
            is_active: true,
          };
        }
        this.errors = {};
      },
    },
  },
  methods: {
    toTimeInput(v) {
      if (!v) return "";
      return String(v).substring(0, 5);
    },
    validate() {
      this.errors = {};
      if (this.form.delivery_type_id === "" || this.form.delivery_type_id == null) {
        this.errors.delivery_type_id = "Выберите тип доставки";
      }
      if (!this.form.time_from) this.errors.time_from = "Обязательное поле";
      if (!this.form.time_to) this.errors.time_to = "Обязательное поле";
      return Object.keys(this.errors).length === 0;
    },
    submit() {
      if (!this.validate()) return;
      this.$emit("submit", {
        delivery_type_id: Number(this.form.delivery_type_id),
        time_from: this.form.time_from,
        time_to: this.form.time_to,
        is_active: this.form.is_active,
      });
    },
  },
};
</script>

<style scoped>
.form-control {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.form-control--error {
  border-color: #e34a4a;
}
.error-message {
  color: #e34a4a;
  font-size: 0.875rem;
}
</style>
